import { render } from "./DialogcreaCliente.vue?vue&type=template&id=3216de72&scoped=true"
import script from "./DialogcreaCliente.vue?vue&type=script&lang=js"
export * from "./DialogcreaCliente.vue?vue&type=script&lang=js"

import "./DialogcreaCliente.vue?vue&type=style&index=0&id=3216de72&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3216de72"]])

export default __exports__